












































import { Vue, Component } from "vue-property-decorator"
import api from "../honcierge-api"
import Edit from "@/components/InlineAdvertisements/Edit.vue"
import TableItemIsEnabled from "@/components/_share/TableItemIsEnabled.vue"

import { DataTableHeader } from "vuetify/types"
import { InlineAdvertisement } from "types/inlineAdvertisement"

@Component({ components: { Edit, TableItemIsEnabled } })
export default class InlineAdvertisements extends Vue {
  private loading = true
  private dialog = false
  private inlineAdvertisements: InlineAdvertisement["data"][] = []

  get headers(): DataTableHeader[] {
    return [
      { text: "ID", value: "id" },
      { text: "スクリプト", value: "script" },
      { text: "詳細", value: "description" },
      { text: "google広告かどうか", value: "isGoogle" },
      { text: "操作", value: "action", sortable: false },
    ]
  }

  public created(): void {
    this.getInlineAdvertisements()
  }

  private getInlineAdvertisements() {
    api
      .getInlineAdvertisements()
      .then((res) => {
        this.inlineAdvertisements = res.data.inlineAdvertisements
      })
      .catch(() => {
        this.$toasted.error("インライン広告一覧の取得に失敗しました")
      })
      .finally(() => {
        this.loading = false
      })
  }

  private updateInlineAdvertisement() {
    this.getInlineAdvertisements()
  }

  private async open(id?: number) {
    if (id) {
      const refs = this.$refs[id] as InstanceType<typeof Edit>
      if (Array.isArray(refs)) {
        refs[0].open()
      } else {
        refs.open()
      }
    } else {
      const newDialog = this.$refs.newDialog as InstanceType<typeof Edit>
      newDialog.open()
    }
  }
}
